__webpack_require__.p = "/projects/react/calculator-bmi/";